/**
 * 한국어 원문 → 독일어 사전. 키 규칙과 폴백(→영어→한국어)은 en.js·index.js 참고.
 * 이 파일은 번역 TSV 에서 생성했다. 원문 문구를 바꾸면 en.js 와 함께 키를 고쳐야 한다.
 */
const de = {
    "지도 보러가기": "Karte öffnen",
    "3D 웹사이트 보러가기": "Zur 3D-Website",
    "컨설팅 받아보기": "Beratung anfragen",
    "로그인 후 이용가능합니다.": "Bitte melden Sie sich an, um diese Funktion zu nutzen.",
    "프롭메이트 로고": "PROPMATE-Logo",
    "집을 짓는 새로운 방식, 프롭메이트": "Eine neue Art zu bauen. PROPMATE.",
    "오직 당신만을 위한 최적화된 디자인": "Ein Design, ganz auf Sie zugeschnitten",
    "단 하나의 디자인을 만들어 냅니다. 고객 만족을 최우선으로한 프롭메이트만의 디자인을 체험해보세요.": "Wir entwerfen ein Unikat – nur für Sie. Erleben Sie Gestaltung, bei der Ihre Zufriedenheit an erster Stelle steht.",
    "엄선된 전문 업체로 최상의 시공성": "Ausgewählte Fachbetriebe, erstklassige Bauausführung",
    "다양한 포트폴리오를 가진 최고의 업체와 함께합니다. 그들의 작품을 감상해보세요.": "Wir arbeiten mit führenden Unternehmen zusammen, die umfangreiche Referenzen vorweisen. Sehen Sie sich ihre Projekte an.",
    "고객 예산에 맞춘 금융 컨설팅": "Finanzberatung, abgestimmt auf Ihr Budget",
    "고객 예산안에 최적화된 자금 활용 방안을 확인해보세요. 언제든 상담해 드립니다.": "Finden Sie den besten Weg, Ihr Budget einzusetzen. Wir beraten Sie jederzeit.",
    "고객 예산 안에 최적화된 자금 활용 방안을 확인해보세요. 언제든 상담해 드립니다.": "Finden Sie den besten Weg, Ihr Budget einzusetzen. Wir beraten Sie jederzeit.",
    "지도 기반 토지정보 확인 시스템": "Kartenbasiertes Grundstücksinformationssystem",
    "원하는 땅을 찾아보세요": "Finden Sie das passende Grundstück",
    "원하는 땅을 찾아보세요.": "Finden Sie das passende Grundstück.",
    "얼마에 어떤 건물을 지을 수 있는지 직접 확인하세요.": "Sehen Sie selbst, was Sie bauen können – und zu welchen Kosten.",
    "언제 어디서나, 3D Viewer": "Überall und jederzeit – 3D-Viewer",
    "언제 어디서나, 3D Veiwer": "Überall und jederzeit – 3D-Viewer",
    "Web기반의 3D뷰어로,": "Mit einem webbasierten 3D-Viewer",
    "언제 어디서나 여러분의 계획안을 직관적으로 확인하세요.": "prüfen Sie Ihre Pläne auf einen Blick, wo immer Sie sind.",
    "집 짓는데 필요한 필수 정보 컨설팅": "Beratung zu allem, was Sie zum Bauen brauchen",
    "집을 짓기에 필요한 수많은 궁금증": "So viele Fragen das Bauen auch aufwirft –",
    "언제든 물어보고 결정하세요.": "stellen Sie sie jederzeit und entscheiden Sie dann.",
    "언제 어디서나,": "Überall und jederzeit –",
    "집 짓는데 필요한": "Beratung zu allem,",
    "필수 정보 컨설팅": "was Sie zum Bauen brauchen",
    "확인 시스템": "im Überblick",
    "지도 기반 토지정보": "Kartenbasierte Grundstücksinformationen",
    "원하는 땅을 직접 찾아보세요.": "Suchen Sie Ihr Wunschgrundstück selbst.",
    "토지가 가진 토지 이용 규제정보, 각종 법령 정보를": "Nutzungsbeschränkungen und alle für ein Grundstück geltenden Vorschriften",
    "종합하여 클릭만으로 쉽게 확인해볼 수 있습니다.": "werden gebündelt – ein Klick genügt, um alles zu sehen.",
    "대한민국 어디든 원하는 땅을 찾아,": "Wählen Sie ein beliebiges Grundstück in Korea",
    "땅이 가진 정보를 눈으로 확인해 보세요.": "und sehen Sie mit eigenen Augen, was in ihm steckt.",
    "원하는 토지에 어떤 건축물을 지을 수 있는지,": "Was Sie darauf bauen dürfen,",
    "어느 정도 규모의 건물을 건축할 수 있는지,": "wie groß das Gebäude sein darf,",
    "해당 크기의 건축을 하려면 어느 정도의 비용이 소요되는지,": "was ein Bau dieser Größe kosten würde",
    "초기 건축 자본은 얼마가 필요한지 등을": "und wie viel Startkapital Sie benötigen –",
    "여러분이 직접 확인하시고 건축하세요!": "prüfen Sie alles selbst – und dann bauen Sie los!",
    "언제 어디서나, 3D 뷰어": "Überall und jederzeit – 3D-Viewer",
    "설계한 건축물을 3차원 공간에서 체험하세요.": "Erleben Sie Ihren Entwurf in drei Dimensionen.",
    "어려운 도면 대신, 3D지만 이미지 대신, 값비싼 뷰어 프로그램 대신!": "Keine schwer lesbaren Pläne, keine flachen Renderings, keine teure Viewer-Software.",
    "손쉬운 접근으로 직관적인 내용을 확인할 수 있습니다.": "Einfach zu öffnen – und was Sie sehen, erklärt sich von selbst.",
    "URL 링크 전달만으로 인터넷이 가능한 곳 어디서든 접속 가능합니다.": "Ein Link genügt – er öffnet sich überall mit Internetverbindung.",
    "대면 미팅, VR 체험, 재질 변경 모두 가능합니다.": "Persönliche Besprechungen, VR-Rundgänge und Materialwechsel – alles ist möglich.",
    "지금 바로 확인하세요!": "Überzeugen Sie sich jetzt selbst.",
    "집을, 혹은 건물을 짓는데 전문가의 도움 없이는 불가능합니다.": "Ohne fachkundige Hilfe lässt sich kein Haus und kein Gebäude bauen.",
    "나에게 꼭 맞는 집을 짓기에 필요한 각 분야 전문가들이 상시 대기 중입니다.": "Fachleute aller Bereiche stehen bereit, damit Sie das Haus bauen, das zu Ihnen passt.",
    "건축설계, 인허가, 시공, 인테리어, 금융 등": "Architektur, Genehmigungen, Bau, Innenausbau, Finanzierung –",
    "해당 전문가에게 직접 물어보고 결정하세요.": "fragen Sie direkt die richtige Fachperson und entscheiden Sie dann.",
    "고객 맞춤의 이해하기 쉽고 단순한 용어로 변환하여 설명해 드립니다.": "Wir erklären alles verständlich und auf Sie zugeschnitten.",
    "부담 없이 언제든 연락주세요!": "Melden Sie sich jederzeit – ganz unverbindlich.",
    "대표 | 고호준": "Geschäftsführung | Ko Ho-jun",
    "대표이사 | 고 호 준": "Geschäftsführung | Ko Ho-jun",
    "개인정보 관리 책임자 | 이형우": "Datenschutzbeauftragte Person | Lee Hyoung-woo",
    "개인정보 관리 책임자 | 이 형 우": "Datenschutzbeauftragte Person | Lee Hyoung-woo",
    "사업자등록번호 | 469-81-03262": "Unternehmens-Nr. | 469-81-03262",
    "회사소개": "Über uns",
    "이용약관": "Nutzungsbedingungen",
    "개인정보처리방침": "Datenschutzerklärung",
    "위치기반 서비스 이용약관": "Bedingungen für Standortdienste",
    "올바른 주소를 입력 혹은 클릭해주세요.": "Bitte geben Sie eine gültige Adresse ein oder klicken Sie eine an.",
    "검색 결과가 없습니다.": "Keine Ergebnisse gefunden.",
    "검색 결과 없음": "Keine Ergebnisse",
    "검색에 실패하였습니다.": "Die Suche ist fehlgeschlagen.",
    "주소를 찾을 수 없습니다.": "Die Adresse wurde nicht gefunden.",
    "주소 오류": "Adressfehler",
    "지오코딩 에러": "Geokodierungsfehler",
    "하천은 선택하실 수 없습니다.": "Flüsse können nicht ausgewählt werden.",
    "도로는 선택하실 수 없습니다.": "Straßen können nicht ausgewählt werden.",
    "실거래가": "Kaufpreis",
    "지도를 탐색하여 토지를 선택하거나 주소를 검색해주세요.": "Bewegen Sie die Karte und wählen Sie ein Flurstück oder suchen Sie eine Adresse.",
    "신축할 필지를 찾아보세요!": "Baugrundstück suchen",
    "지적도": "Katasterkarte",
    "거리레이어": "Straßen-Layer",
    "전체화면": "Vollbild",
    "일반": "Standard",
    "위성": "Satellit",
    "로드뷰": "Straßenansicht",
    "반경": "Radius",
    "면적": "Fläche",
    "거리": "Entfernung",
    "건물 실거래가 조회 금액": "Kaufpreisspanne",
    "확인": "Bestätigen",
    "1억": "100 Mio. ₩",
    "5억": "500 Mio. ₩",
    "10억": "1 Mrd. ₩",
    "30억": "3 Mrd. ₩",
    "60억": "6 Mrd. ₩",
    "아파트": "Wohnung",
    "오피스텔": "Officetel",
    "공장창고등": "Fabrik / Lager",
    "단독다가구": "Ein- / Mehrparteienhaus",
    "상업업무용": "Gewerbe / Büro",
    "연립다세대": "Mehrfamilienhaus",
    "토지": "Grundstück",
    "토지정보": "Grundstück",
    "건축정보": "Gebäude",
    "예상공사비": "Baukosten",
    "토지평가": "Bewertung",
    "가격비교": "Preistrend",
    "시뮬레이션": "Simulation",
    "신축정보": "Neubau",
    "건물정보": "Bestand",
    "AI 분석": "KI-Analyse",
    "상세": "Details",
    "개발제한구역으로": "Dieses Grundstück liegt im Grüngürtel (Entwicklungssperrgebiet) –",
    "건축이 불가능한 토지입니다.": "eine Bebauung ist hier nicht zulässig.",
    "토지 면적": "Grundstücksfläche",
    "지목": "Nutzungsart",
    "용도": "Gebietsart",
    "건축가능용도": "Zulässige Nutzung",
    "공시지가": "Bodenrichtwert",
    "지형높이": "Geländehöhe",
    "지형형상": "Grundstücksform",
    "데이터기준일자": "Datenstand",
    "건축 면적": "Bebaute Fläche",
    "연면적": "Bruttogeschossfläche",
    "건폐율": "Grundflächenzahl",
    "용적률": "Geschossflächenzahl",
    "총액": "Gesamt",
    "설계비": "Planungskosten",
    "자재비": "Materialkosten",
    "인건비": "Lohnkosten",
    "경비": "Gemeinkosten",
    "건물정보가 없습니다.": "Keine Gebäudeinformationen vorhanden.",
    "건물정보 {n}": "Gebäude {n}",
    "건물명": "Gebäudename",
    "건물동명": "Gebäudeblock",
    "건추물구조명": "Bauart",
    "주도용도명": "Hauptnutzung",
    "건물높이": "Höhe",
    "지상층수": "Oberirdische Geschosse",
    "지하층수": "Unterirdische Geschosse",
    "허가일자": "Genehmigungsdatum",
    "총주차대수": "Stellplätze",
    "총주차장면적": "Parkfläche",
    "정보 없음": "Keine Daten",
    "AI 평가 가치": "KI-Bewertung",
    "AI 분석 요약": "KI-Zusammenfassung",
    "{amount}원, {percent}%": "{amount} ₩, {percent} %",
    "내용을 불러오는중...": "Wird geladen …",
    "가격 비교 정보가 없습니다.": "Keine Preisdaten verfügbar.",
    "건축 예정일": "Geplanter Baubeginn",
    "건축 용도": "Gebäudenutzung",
    "선택하세요": "Auswählen",
    "시뮬레이션 중...": "Simulation läuft …",
    "시뮬레이션 하기": "Simulation starten",
    "추천 구매 시기": "Empfohlener Kaufzeitpunkt",
    "완공 예정일": "Voraussichtliche Fertigstellung",
    "예상 수익률": "Erwartete Rendite",
    "AI 건축물/토지 찾기": "KI-Suche: Gebäude & Grundstücke",
    "AI 분석을 불러오는 중입니다. 잠시만 기달려주세요.": "Die KI-Analyse wird geladen. Einen Moment bitte.",
    "AI 데이터 분석 중 오류가 발생했습니다.": "Bei der KI-Analyse ist ein Fehler aufgetreten.",
    "주소 정보가 없습니다.": "Keine Adresse ausgewählt.",
    "건축 예정일은 YYYY.MM 형식으로 입력하고, 건축 용도를 선택해주세요.": "Geben Sie den geplanten Baubeginn im Format JJJJ.MM ein und wählen Sie eine Gebäudenutzung.",
    "AI 시뮬레이션 중 오류가 발생했습니다.": "Bei der KI-Simulation ist ein Fehler aufgetreten.",
    "전체": "Alle",
    "북마크를 등록해주세요!": "Legen Sie ein Lesezeichen an, um zu beginnen.",
    "대지면적": "Grundstücksfläche",
    "견적 비교하기": "Kosten vergleichen",
    "새 리스트 추가": "Neue Liste anlegen",
    "리스트는 최대 3개까지 입니다.": "Sie können bis zu 3 Listen anlegen.",
    "새 리스트명을 입력해주세요": "Name der neuen Liste",
    "색상 선택": "Farbe",
    "리스트 저장": "Liste speichern",
    "토지의 별명을 입력해주세요.": "Geben Sie dem Grundstück einen Namen.",
    "새 리스트를 추가해 주세요.": "Bitte legen Sie zuerst eine Liste an.",
    "메모": "Notiz",
    "저장": "Speichern",
    "건축용도 가능여부": "Zulässige Nutzungen",
    "건축가능": "Zulässig",
    "건축불가": "Unzulässig",
    "건축제한": "Eingeschränkt",
    "조건부가능": "Bedingt zulässig",
    "[조건·제한·예외사항]": "[Mit Auflagen]",
    "(조건·제한·예외사항 : {detail})": "(Auflagen / Einschränkungen / Ausnahmen: {detail})",
    "보다 자세한 내용은 토지이음에서 확인해주시길 바랍니다.": "Einzelheiten finden Sie im staatlichen Flächennutzungsportal Toji-Eum.",
    "토지이음 바로가기": "Toji-Eum öffnen",
    "조건이 붙습니다. 전체 내용은 아래 토지이음에서 확인하세요.": "Es gelten Auflagen – den vollständigen Text finden Sie unten bei Toji-Eum.",
    "평": " Pyeong",
    "(원/㎡)": "(KRW/m²)",
    "{n}대": "Stellplätze: {n}",
    "건축물사진": "Architekturfoto",
    "프롭메이트는 지도 기반으로": "PROPMATE ist ein kartenbasierter Dienst, der",
    "토지 관련 모든 정보를 신속하고 정확하게 제공하는 전문 서비스를 자랑합니다.": "alle Grundstücksinformationen schnell und präzise bereitstellt.",
    "강력한 데이터베이스와 AI 기술을 바탕으로,": "Auf Basis einer umfassenden Datenbank und KI",
    "고객이 원하는 건물을 지을 수 있는 규모와 예상 비용을 정밀하게 예측합니다.": "prognostizieren wir genau, wie groß Sie bauen können und was es kostet.",
    "또한, 건축 가능 용도에 따른 다양한 개발 옵션을 제시하며,": "Außerdem zeigen wir die Entwicklungsoptionen für jede zulässige Nutzung,",
    "끊임없이 발전하는 기술과 정보를 통해 고객이 가장 현명한 결정을 내릴 수 있도록 지원합니다.": "damit Sie – gestützt auf stetig weiterentwickelte Technologie und Daten – die beste Entscheidung treffen.",
    "항상 고객 만족을 최우선 가치로 삼으며,": "Ihre Zufriedenheit steht bei allem an erster Stelle,",
    "함께하는 모든 건축 과정에서 안도감과 신뢰를 제공하는 든든한 파트너가 되겠습니다.": "und wir möchten in jeder Bauphase ein verlässlicher Partner sein.",
    "프롭메이트와 함께라면,": "Mit PROPMATE",
    "혁신적인 기술과 신뢰할 수 있는 전문성을 통해 고객의 꿈을 현실로 만들어 드립니다.": "werden Ihre Pläne dank innovativer Technologie und verlässlicher Expertise Wirklichkeit.",
    "IR파일이미지": "IR-Unterlagen",
    "기업소개서": "Unternehmensbroschüre",
    "회사소개파일이미지": "Unternehmensbroschüre (Datei)",
    "회사소개서 언어 선택": "Sprache der Broschüre wählen",
    "한국어": "Koreanisch",
    "한국어 🇰🇷": "Koreanisch 🇰🇷",
    "AI가 조건에 맞는 토지를 찾고 있습니다...": "Die KI sucht passende Grundstücke …",
    "AI 검색이 완료되었습니다!": "KI-Suche abgeschlossen.",
    "검색 중 오류가 발생했습니다. 다시 시도해주세요.": "Bei der Suche ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    "{region} 지역의 적합한 토지": "Geeignetes Grundstück in {region}",
    "현재 AI 서비스에 일시적인 문제가 발생했습니다. 부동산 전문가와 상담하시기 바랍니다.": "Der KI-Dienst ist vorübergehend nicht verfügbar. Bitte wenden Sie sich an eine Immobilienfachperson.",
    "원하는 토지/건축을 찾기 힘드신가요?": "Sie finden nicht das passende Grundstück oder Gebäude?",
    "AI 토지/건축물 찾기": "KI-Suche: Grundstücke & Gebäude",
    "원하는 지역을 선택해주세요.": "Wählen Sie die gewünschten Regionen.",
    "(최대 3개까지 선택 가능)": "(bis zu 3)",
    "지역을 선택해주세요": "Region wählen",
    "AI 토지/건축물 지역 선택 아이콘": "Regionsauswahl",
    "예산안을 알려주세요.": "Nennen Sie uns Ihr Budget.",
    "원하는 토지/건축물에 대해 설명해주세요.": "Beschreiben Sie das gewünschte Grundstück oder Gebäude.",
    "ex) 서울, 상업시설, 200평 이상, 10억~30억의 예산안\n'단독주택을 짓고 싶은데 조망이 좋고 조용한 동네면 좋겠어.'": "z. B. Seoul, Gewerbe, ab 200 Pyeong, Budget 1–3 Mrd. ₩\n„Ich möchte ein Einfamilienhaus in ruhiger Lage mit schöner Aussicht bauen.“",
    "검색 중...": "Suche läuft …",
    "검색하기": "Suchen",
    "총 {n}건의 토지를 찾았어요!": "Gefundene Grundstücke: {n}",
    "접기": "Einklappen",
    "상세 보기": "Details anzeigen",
    "AI 추천 이유": "Warum die KI das empfiehlt",
    "다시하기": "Neu starten",
    "서울": "Seoul",
    "부산": "Busan",
    "대구": "Daegu",
    "인천": "Incheon",
    "광주": "Gwangju",
    "대전": "Daejeon",
    "울산": "Ulsan",
    "세종": "Sejong",
    "경기도": "Gyeonggi-do",
    "강원도": "Gangwon-do",
    "충청북도": "Chungcheongbuk-do",
    "충청남도": "Chungcheongnam-do",
    "전라북도": "Jeollabuk-do",
    "전라남도": "Jeollanam-do",
    "경상북도": "Gyeongsangbuk-do",
    "경상남도": "Gyeongsangnam-do",
    "제주도": "Jeju-do",
    "견적 비교할 토지들을 선택해주세요!": "Wählen Sie die Grundstücke, die Sie vergleichen möchten.",
    "견적 비교를 위해 데이터를 불러오는 중입니다.": "Vergleichsdaten werden geladen …",
    "예상 공사비": "Geschätzte Baukosten",
    "{purpose} 건축 불가": "{purpose} nicht zulässig",
    "건축 가능 용도": "Zulässige Nutzungen",
    "단독주택": "Einfamilienhaus",
    "공동주택": "Geschosswohnungsbau",
    "제1종 근린생활시설": "Nahversorgung (Kl. 1)",
    "제2종 근린생활시설": "Nahversorgung (Kl. 2)",
    "문화 및 집회시설": "Kultur & Versammlung",
    "판매시설": "Handel",
    "운동시설": "Sport",
    "숙박시설": "Beherbergung",
    "의료시설": "Gesundheit",
    "교육연구시설": "Bildung & Forschung",
    "노유자시설": "Senioren & Kinder",
    "업무시설": "Büro",
    "종교시설": "Religion",
    "컨설팅 받고자 하는 항목들을 선택해주세요. (중복선택 가능)": "Wählen Sie, wozu Sie beraten werden möchten. (Mehrfachauswahl möglich)",
    "컨설팅 받고자하는 건축용도를 입력해주세요. ex)단독주택/다가구주택": "Gewünschte Gebäudenutzung eingeben, z. B. Einfamilienhaus / Mehrparteienhaus",
    "컨설팅 접수가 완료 되었습니다. 영업일 기준 5일이내로 답변 드리겠습니다. 모든 접수는 순차적으로 답변 드립니다. 감사합니다.": "Ihre Anfrage ist eingegangen. Wir antworten innerhalb von 5 Werktagen in der Reihenfolge des Eingangs. Vielen Dank.",
    "컨설팅 문의를 보냈습니다.": "Ihre Beratungsanfrage wurde gesendet.",
    "중복선택 가능": "Mehrfachauswahl möglich",
    "ex)단독주택/다가구주택": "z. B. Einfamilienhaus / Mehrparteienhaus",
    "컨설팅 항목 선택": "Wozu möchten Sie beraten werden?",
    "건축 용도 선택": "Gebäudenutzung",
    "건축예산": "Budget",
    "상세 문의": "Ihre Anfrage",
    "컨설팅 받고자 하는 항목들에 대한 설명을 입력해주세요.\r\n \r\n \r\nex)  가지고 있는 땅에 단독 주택을 짓고 싶어요. 자금과 시간이 얼마나 드는지 알고 싶어요.": "Beschreiben Sie bitte genauer, was Sie brauchen.\r\n \r\n \r\nz. B.  Ich möchte auf meinem eigenen Grundstück ein Einfamilienhaus bauen und wissen, was es kostet und wie lange es dauert.",
    "현재 보고 있는 토지": "Das aktuell angezeigte Grundstück",
    "설계 / 인허가": "Planung / Genehmigung",
    "시공": "Bau",
    "인테리어": "Innenausbau",
    "예상 공사비 / 예상소요기간": "Kosten / Bauzeit",
    "토지 매입": "Grundstückskauf",
    "기타 (상세문의 작성)": "Sonstiges (bitte unten beschreiben)",
    "3억": "300 Mio. ₩",
    "6억": "600 Mio. ₩",
    "20억": "2 Mrd. ₩",
    "주소 | 서울시 관악구 문성로 199-1 2층": "Adresse | 1. OG, 199-1 Munseong-ro, Gwanak-gu, Seoul",
    "사업자등록번호 | 628-40-00876": "Unternehmens-Nr. | 628-40-00876",
    "위치기반서비스": "Standortdienste",
    "프로모션 정보 수신": "Werbenachrichten",
    "로그인": "Anmelden",
    "로그인박스": "Anmeldung",
    "회원가입": "Registrieren",
    "회원가입박스": "Registrierung",
    "아이디 찾기": "ID vergessen",
    "아이디찾기": "ID vergessen",
    "비밀번호 재설정": "Passwort zurücksetzen",
    "환영합니다!": "Willkommen!",
    "집을 짓기 위한 새로운 여정,": "Ihr Weg zum eigenen Haus –",
    "프롭메이트와 함께 하세요!": "starten Sie ihn mit PROPMATE!",
    "아이디 와 비밀번호를 모두 입력해주세요.": "Bitte geben Sie ID und Passwort ein.",
    "프롭메이트 아이디 입력": "PROPMATE-ID",
    "프롭메이트 비밀번호 입력": "PROPMATE-Passwort",
    "카카오로그인버튼": "Kakao-Anmeldebutton",
    "카카오로그인": "Mit Kakao anmelden",
    "네이버로그인버튼": "Naver-Anmeldebutton",
    "네이버로그인": "Mit Naver anmelden",
    "이메일을 입력해주세요.": "Bitte geben Sie Ihre E-Mail-Adresse ein.",
    "이름(기업명)을 입력해주세요.": "Bitte geben Sie Ihren Namen (oder Firmennamen) ein.",
    "전화번호를 입력해주세요.": "Bitte geben Sie Ihre Telefonnummer ein.",
    "비밀번호를 입력해주세요.": "Bitte geben Sie ein Passwort ein.",
    "아이디를 입력해주세요.": "Bitte geben Sie eine ID ein.",
    "회원가입이 완료되었습니다.": "Ihr Konto wurde erstellt.",
    "아이디 입력": "ID",
    "영문 대소문자와 숫자 4~12자리": "4–12 Zeichen (A–Z, a–z, 0–9)",
    "비밀번호 입력": "Passwort",
    "영문 대소문자와 숫자 8~20자리": "8–20 Zeichen (A–Z, a–z, 0–9)",
    "비밀번호 확인란을 입력해주세요.": "Bitte bestätigen Sie Ihr Passwort.",
    "비밀번호 확인": "Passwort bestätigen",
    "비밀번호가 일치하지 않습니다.": "Die Passwörter stimmen nicht überein.",
    "전화번호 입력 (숫자만)": "Telefonnummer (nur Ziffern)",
    "이름(기업명) 입력": "Name (oder Firmenname)",
    "이메일 입력": "E-Mail",
    "이메일 형식으로 입력해주세요.": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    "선택": "Optional",
    "남자": "Männlich",
    "여자": "Weiblich",
    "년(4자)": "Jahr (4-stellig)",
    "--월": "-- Monat",
    "1월": "Januar",
    "2월": "Februar",
    "3월": "März",
    "4월": "April",
    "5월": "Mai",
    "6월": "Juni",
    "7월": "Juli",
    "8월": "August",
    "9월": "September",
    "10월": "Oktober",
    "11월": "November",
    "12월": "Dezember",
    "일": "Tag",
    "직업 선택": "Beruf wählen",
    "예비 건축주": "Angehende Bauherrschaft",
    "건축업 종사자": "Baufachkraft",
    "프롭메이트 정보수집에 모두 동의합니다.": "Ich stimme allen Bedingungen und Einwilligungen von PROPMATE zu.",
    "프롭메이트 이용약관 동의": "Zustimmung zu den PROPMATE-Nutzungsbedingungen",
    "필수": "Pflicht",
    "자세히보기": "Mehr lesen",
    "개인정보 수집 및 이용 동의": "Zustimmung zur Erhebung und Nutzung personenbezogener Daten",
    "위치기반서비스 이용약관 동의": "Zustimmung zu den Bedingungen für Standortdienste",
    "프로모션 정보 수신 동의": "Zustimmung zum Erhalt von Werbenachrichten",
    "가입한 이메일 입력": "Bei der Registrierung verwendete E-Mail",
    "가입한 아이디 입력": "Bei der Registrierung verwendete ID",
    "이메일에 인증번호를 보냈습니다.": "Wir haben Ihnen einen Bestätigungscode per E-Mail gesendet.",
    "인증완료.": "Bestätigt.",
    "인증에 실패했습니다. 다시 인증요청 해주시길 바랍니다.": "Die Bestätigung ist fehlgeschlagen. Bitte fordern Sie einen neuen Code an.",
    "비밀번호 변경완료": "Ihr Passwort wurde geändert.",
    "인증요청": "Code senden",
    "인증번호": "Bestätigungscode",
    "인증번호 입력": "Code eingeben",
    "인증확인": "Bestätigen",
    "입력안함": "Nicht angegeben",
    "내 정보": "Mein Profil",
    "정보 수정": "Profil bearbeiten",
    "내정보 수정 박스": "Profil bearbeiten",
    "수정완료": "Speichern",
    "취소": "Abbrechen",
    "닉네임변경": "Namen ändern",
    "닉네임변경완료버튼": "Namensänderung bestätigen",
    "이메일을 입력해 주세요.": "Bitte geben Sie Ihre E-Mail-Adresse ein.",
    "핸드폰 번호를 입력해 주세요.": "Bitte geben Sie Ihre Mobilnummer ein.",
    "이름을 입력해 주세요.": "Bitte geben Sie Ihren Namen ein.",
    "성별을 선택해 주세요.": "Bitte wählen Sie Ihr Geschlecht.",
    "생년월일을 입력해 주세요.": "Bitte geben Sie Ihr Geburtsdatum ein.",
    "직업을 선택해 주세요.": "Bitte wählen Sie Ihren Beruf.",
    "직업을 선택해 주세요": "Beruf wählen",
    "개인정보 이용내역": "Nutzung personenbezogener Daten",
    "조회": "Anzeigen",
    "북마크": "Lesezeichen",
    "대지면적  :": "Grundstücksfläche:",
    "지도페이지로이동": "Zur Karte",
    "지도에서 북마크를 등록해주세요!": "Fügen Sie Lesezeichen auf der Karte hinzu.",
    "지도 바로가기": "Karte öffnen",
    "삭제하기": "Löschen",
    "수정하기": "Bearbeiten",
    "뉴스를 불러오는 중...": "Neuigkeiten werden geladen …",
    "등록된 뉴스가 없습니다.": "Noch keine Neuigkeiten.",
    "이전": "Zurück",
    "다음": "Weiter",
    "공시지가 (만원/㎡)": "Bodenrichtwert (10.000 KRW/m²)",
    "5개년 공시지가 그래프": "Bodenrichtwert der letzten 5 Jahre",
    "AI 예측 5년 후 평당 가격 (단위: 원)": "KI-Prognose über 5 Jahre – Preis pro Pyeong (KRW)",
    "AI 평당 가격 예측 그래프": "KI-Prognose: Preis pro Pyeong",
    "{amount}원": "{amount} ₩",
    "{amount}원 ({percent}%)": "{amount} ₩ ({percent} %)",
    "변동 없음": "Keine Änderung",
    "최저가": "Tiefstwert",
    "최고가": "Höchstwert",
    "토지가격": "Bodenpreis",
    "투자가치": "Anlagepotenzial",
    "법적 규제": "Regulierung",
    "소음": "Lärm",
    "인구 규모": "Bevölkerung",
    "교통 및 접근성": "Verkehr & Anbindung",
    "지형 및 토양": "Gelände & Boden",
    "편의시설": "Ausstattung",
    "인프라 및 공공시설": "Infrastruktur",
    "평가": "Bewertung",
    "{n}점": "{n} Pkt.",
    "3D웹사이트 보러가기": "Zur 3D-Website",
    "게시글을 작성해주세요": "Beitrag verfassen",
    "건축의 시작이,\n더 이상 전문가만의 영역이 아니길 바란다.": "Bauen soll nicht länger\nnur Sache von Fachleuten sein.",
    "#건축가 #창업가 #유튜버": "#Architektur #Gründung #YouTube",
    "나는 방향을 설계하고,\n팀은 파도를 만든다.": "Ich gebe die Richtung vor,\ndas Team schlägt Wellen.",
    "#분위기메이커 #햇살캐 #꺄르르": "#GuteLaune #Sonnenschein #Kichern",
    "설계는 정답이 없지만 오답은 있다.": "Beim Entwerfen gibt es kein Richtig – aber ein Falsch.",
    "#건축가 #궁수 #클라이머": "#Architektur #Bogenschießen #Klettern",
    "불가능한 개발은 없다.\n노력이 필요할 뿐.": "Keine Entwicklung ist unmöglich.\nEs braucht nur Einsatz.",
    "#풀스택 #천재개발자 #플러팅장인": "#Fullstack #Genie #Flirtprofi",
    "모든 것은 ‘기획’으로 시작된다.": "Alles beginnt mit der Planung.",
    "#기획 #감정미적분기 #유빈씨,,바빠요?": "#Planung #Gefühlsrechnung #YubinBistDuBeschäftigt?",
    "버그보다 골절이 먼저 왔다.": "Der Knochenbruch kam vor dem Bug.",
    "#풀스택 #술자바(Sul.js) #손가락404": "#Fullstack #Sul.js #Finger404",
    "데이터는 쿨하게,\n분석은 뜨겁게.": "Kühl bei den Daten,\nheiß bei der Analyse.",
    "#데이터개발자 #동자승 #오픈런러": "#DatenDev #KleinerMönch #OpenRunner",
    "오류는 고쳐도,\n자세는 못 고친다.": "Fehler kann ich beheben,\nmeine Haltung nicht.",
    "#풀스택 #허리404 #래블래용": "#Fullstack #Rücken404 #Raeblaeyong",
    "디자인은 디테일,\n회식은 타이밍.": "Design ist Detail,\nTeamessen ist Timing.",
    "#디자이너 #회식탐지기 #피그마의광대": "#Design #Essensradar #FigmaClown",
    "투명하고 똑똑한 IT 건축 플랫폼 '프롭메이트' 부동산 개발의 새로운 패러다임 열다": "PROPMATE: transparente, intelligente IT-Bauplattform läutet Paradigmenwechsel in der Projektentwicklung ein",
    "프롭메이트, '2024 대한민국 지식재산대전'에서 AI 토지정보 제공 시스템 선봬": "PROPMATE präsentiert sein KI-Grundstücksinformationssystem auf der Korea Intellectual Property Exhibition 2024",
    "프롭메이트, 'NIPA 지역 성과보고회' 성공적 참여": "PROPMATE nimmt an der regionalen Ergebnispräsentation der NIPA teil",
    "프롭메이트, AIoT 국제전시회에서 혁신적 솔루션을 선보이다.": "PROPMATE stellt seine innovative Lösung auf der AIoT International Exhibition vor",
    "프롭메이트, 2024 AIoT 국제전시회 참가... 토지 정보 제공 시스템·3D 가상 시뮬레이션 기술 알린다": "PROPMATE auf der AIoT International Exhibition 2024 – mit Grundstücksinformationssystem und 3D-Simulationstechnik",
    "대": "Bauland",
    "대지": "Bauland",
    "전": "Ackerland",
    "답": "Reisfeld",
    "과수원": "Obstanbaufläche",
    "목장용지": "Weideland",
    "임야": "Wald",
    "광천지": "Mineralquelle",
    "염전": "Salzgarten",
    "공장용지": "Industriegelände",
    "학교용지": "Schulgelände",
    "주차장": "Parkplatz",
    "주유소용지": "Tankstellengelände",
    "창고용지": "Lagergelände",
    "도로": "Straße",
    "철도용지": "Bahngelände",
    "제방": "Damm",
    "하천": "Fluss",
    "구거": "Graben",
    "유지": "Stillgewässer",
    "양어장": "Fischzucht",
    "수도용지": "Wasserwerksgelände",
    "공원": "Park",
    "체육용지": "Sportanlage",
    "유원지": "Freizeitpark",
    "종교용지": "Religiöses Gelände",
    "사적지": "Historische Stätte",
    "묘지": "Friedhof",
    "잡종지": "Sonstige Fläche",
    "제1종전용주거지역": "Reines Wohngebiet Typ 1",
    "제2종전용주거지역": "Reines Wohngebiet Typ 2",
    "제1종일반주거지역": "Allgemeines Wohngebiet Typ 1",
    "제2종일반주거지역": "Allgemeines Wohngebiet Typ 2",
    "제3종일반주거지역": "Allgemeines Wohngebiet Typ 3",
    "준주거지역": "Mischgebiet",
    "중심상업지역": "Kerngebiet",
    "일반상업지역": "Allgemeines Geschäftsgebiet",
    "근린상업지역": "Geschäftsgebiet (Quartier)",
    "유통상업지역": "Handels- und Logistikgebiet",
    "전용공업지역": "Reines Industriegebiet",
    "일반공업지역": "Industriegebiet",
    "준공업지역": "Industriegebiet (gemischt)",
    "보전녹지지역": "Grünzone (Schutz)",
    "생산녹지지역": "Grünzone (Landwirtschaft)",
    "자연녹지지역": "Grünzone (naturnah)",
    "보전관리지역": "Außenbereich (Schutz)",
    "생산관리지역": "Außenbereich (Landwirtschaft)",
    "계획관리지역": "Außenbereich (Planung)",
    "농림지역": "Land- und Forstwirtschaft",
    "자연환경보전지역": "Naturschutzgebiet",
    "개발제한구역": "Grüngürtel (Entwicklungssperre)",
    "정방형": "Quadratisch",
    "가장형": "Rechteckig (breit)",
    "가로장방형": "Rechteckig (breit)",
    "세로장방형": "Rechteckig (tief)",
    "사다리형": "Trapezförmig",
    "부정형": "Unregelmäßig",
    "자루형": "Hinterliegergrundstück",
    "삼각형": "Dreieckig",
    "역삼각형": "Umgekehrt dreieckig",
    "수련시설": "Jugendbildungsstätte",
    "창고시설": "Lager",
    "위험물 저장 및 처리 시설": "Gefahrstoffanlage",
    "자동차 관련 시설": "Kfz-Einrichtung",
    "동물 및 식물 관련 시설": "Agrarbetrieb",
    "교정 및 군사 시설": "Justizvollzug & Militär",
    "방송통신시설": "Rundfunk & Telekom",
    "묘지 관련 시설": "Friedhofseinrichtung",
    "결혼상담소": "Partnervermittlung",
    "고등학교": "Oberschule",
    "골프연습장": "Golfübungsplatz",
    "골프장": "Golfplatz",
    "공공도서관": "Öffentliche Bibliothek",
    "공관": "Dienstwohnung",
    "공중화장실": "Öffentliche Toilette",
    "공회당": "Versammlungshalle",
    "과학관": "Wissenschaftsmuseum",
    "교습소": "Lernstudio",
    "교회": "Kirche",
    "구기장": "Ballsportplatz",
    "국방시설": "Verteidigungsanlage",
    "군사시설": "Militäranlage",
    "궁도장": "Bogenschießanlage",
    "극장": "Theater",
    "근로복지시설": "Arbeitnehmer-Wohlfahrtseinrichtung",
    "금융업소": "Finanzinstitut",
    "기념관": "Gedenkhalle",
    "기도원": "Gebetshaus",
    "기숙사": "Wohnheim",
    "기원": "Go-Club",
    "노래연습장": "Karaoke-Raum",
    "노인복지시설": "Senioreneinrichtung",
    "놀이형시설": "Spieleinrichtung",
    "농수산물공판장": "Agrar- & Fischauktionsmarkt",
    "농수산물도매시장": "Agrar- & Fischgroßmarkt",
    "다가구주택": "Mehrparteienhaus",
    "다세대주택": "Mehrfamilienhaus (klein)",
    "다중생활시설": "Gemeinschaftswohnanlage",
    "다중주택": "Mehrbewohnerhaus",
    "당구장": "Billardsalon",
    "대규모점포": "Großflächiger Einzelhandel",
    "대피소": "Schutzraum",
    "대학교": "Universität",
    "데이터센터": "Rechenzentrum",
    "도시가스배관시설": "Stadtgas-Leitungsanlage",
    "독서실": "Lernraum",
    "동물미용실": "Tierpflegesalon",
    "동물병원": "Tierarztpraxis",
    "동물원": "Zoo",
    "롤러스케이트장": "Rollschuhbahn",
    "마을공동구판장": "Dorfladen (Genossenschaft)",
    "마을공동작업소": "Dorfwerkstatt",
    "마을회관": "Dorfgemeinschaftshaus",
    "목욕장": "Badehaus",
    "문화관": "Kulturzentrum",
    "미술관": "Kunstmuseum",
    "미용원": "Friseursalon",
    "박람회장": "Ausstellungshalle",
    "박물관": "Museum",
    "방송국": "Rundfunkanstalt",
    "변전소": "Umspannwerk",
    "보건소": "Gesundheitsamt",
    "복합유통게임제공업소": "Gaming-Center",
    "볼링장": "Bowlingbahn",
    "봉안당(奉安堂)": "Urnenhalle",
    "부동산중개사무소": "Immobilienbüro",
    "비디오물감상실": "Videoraum",
    "비디오물소극장": "Kleines Videokino",
    "사격장": "Schießstand",
    "사당": "Schrein",
    "사무소": "Büro",
    "사진관": "Fotostudio",
    "사찰": "Buddhistischer Tempel",
    "사회복지시설": "Sozialeinrichtung",
    "산업전시장": "Industriemessehalle",
    "산후조리원": "Wochenbettpflege-Zentrum",
    "상점": "Geschäft",
    "서점": "Buchhandlung",
    "서커스장": "Zirkusgelände",
    "성당": "Katholische Kirche",
    "세차장": "Autowaschanlage",
    "세탁소": "Wäscherei",
    "소방서": "Feuerwache",
    "수녀원": "Nonnenkloster",
    "수도원": "Kloster",
    "수리점": "Reparaturwerkstatt",
    "수영장": "Schwimmbad",
    "수족관": "Aquarium",
    "스케이트장": "Eisbahn",
    "승마장": "Reitanlage",
    "식물원": "Botanischer Garten",
    "실내낚시터": "Indoor-Angelteich",
    "아동복지시설": "Kinderhilfeeinrichtung",
    "안마원": "Massagepraxis",
    "양수장": "Pumpwerk",
    "어린이집": "Kita",
    "에어로빅장": "Aerobic-Studio",
    "연구소": "Forschungsinstitut",
    "연립주택": "Mehrfamilienhaus (groß)",
    "연수원": "Schulungszentrum",
    "연예장": "Unterhaltungsstätte",
    "영화관": "Kino",
    "예식장": "Hochzeitssaal",
    "요양병원": "Pflegeklinik",
    "우체국": "Postamt",
    "유스호스텔": "Jugendherberge",
    "유치원": "Kindergarten",
    "육상장": "Leichtathletikanlage",
    "음악당": "Konzerthalle",
    "의원": "Arztpraxis",
    "이용원": "Herrenfriseur",
    "인터넷컴퓨터게임시설제공업소": "Internetcafé",
    "일반음식점": "Restaurant",
    "자동차영업소": "Autohaus",
    "장의사": "Bestattungsunternehmen",
    "전문대학": "Fachschule",
    "전신전화국": "Fernmeldeamt",
    "접골원": "Praxis für Einrenkung",
    "정수장": "Wasseraufbereitungsanlage",
    "정신병원": "Psychiatrische Klinik",
    "제과점": "Bäckerei",
    "제실": "Ahnenschrein",
    "제조업소": "Fertigungsbetrieb",
    "조산원": "Geburtshaus",
    "종묘배양시설": "Saatgut- & Setzlingsanlage",
    "종합병원": "Krankenhaus",
    "주유소": "Tankstelle",
    "중학교": "Mittelschule",
    "지구대": "Polizeiwache",
    "지역아동센터": "Kinderzentrum",
    "지역자치센터": "Bürgerzentrum",
    "직업훈련소": "Berufsbildungszentrum",
    "차고": "Garage",
    "청소년게임제공업소": "Gaming-Center (jugendfrei)",
    "청소년문화의집": "Jugendkulturhaus",
    "청소년수련관": "Jugendbildungshaus",
    "청소년수련원": "Jugendbildungszentrum",
    "청소년야영장": "Jugendzeltplatz",
    "청소년특화시설": "Jugendeinrichtung (spezialisiert)",
    "체력단련장": "Fitnessstudio",
    "체육관": "Sporthalle",
    "체육도장": "Kampfsportschule",
    "체험관": "Erlebniszentrum",
    "초등학교": "Grundschule",
    "총포판매소": "Waffengeschäft",
    "촬영소": "Filmstudio",
    "출판사": "Verlag",
    "치과병원": "Zahnklinik",
    "치과의원": "Zahnarztpraxis",
    "침술원": "Akupunkturpraxis",
    "탁구장": "Tischtennishalle",
    "테니스장": "Tennisplatz",
    "파출소": "Polizeiposten",
    "표구점": "Bilderrahmengeschäft",
    "하역장": "Verladeplatz",
    "학원": "Nachhilfeinstitut",
    "한방병원": "Klinik (Koreanische Medizin)",
    "한의원": "Praxis (Koreanische Medizin)",
    "회의장": "Konferenzsaal",
    "휴게음식점": "Café / Imbiss",
    "Log In": "Anmelden",
    "Log Out": "Abmelden",
    "About": "Über uns",
    "People": "Team",
    "News": "Neuigkeiten",
    "My page": "Mein Konto",
    "ID": "ID",
    "Password": "Passwort",
    "Phone Number": "Telefonnummer",
    "PhoneNumber": "Telefonnummer",
    "Phone": "Telefon",
    "Email": "E-Mail",
    "EMAIL": "E-MAIL",
    "Gender": "Geschlecht",
    "Birthday": "Geburtsdatum",
    "Occupational": "Beruf",
    "Occupation": "Beruf",
    "Download": "Herunterladen",
    "Introduction": "Vorstellung",
    "English": "Englisch",
    "SCORE": "PUNKTE",
    "Loading...": "Wird geladen …",
};

export default de;
